import * as React from 'react';
import { Route, withRouter, Switch } from 'react-router-dom';
import { CssBaseline } from '@material-ui/core';
import { hot } from 'react-hot-loader';

import {
    ScrollToTop, PrivateRoute, PageNotFound, ErrorBoundary,
} from '../youwell-common/components';
import { LoadAppContent, StartSession, LoadOrgConfig } from '../common/components';

import urls from './urls';

import Inside from '../features/inside/Index';
import Outside from '../features/outside/Index';
import Public from '../features/public/Index';
import Preview from '../features/preview/Index';
import LoadLanguageData from '../youwell-common/components/LoadLanguageData';
import SingleTaskPage from '../features/singlepage/Index';
import OutsideProgram from '../features/outsideProgram/Index';
import External from '../features/external/Index';
import { useYouwellSelector } from './store';
import { authTypes } from '../youwell-common/Auth';

const OutsideRoute = () => {
    const appConfig = useYouwellSelector(state => state.pageSettings.appConfig);

    if (appConfig.publicProgramId || appConfig.publicPrograms?.length > 0) return <OutsideProgram />;

    return <Outside />;
}

class App extends React.Component {
    render() {
        return (
            <>
                <CssBaseline />
                <ScrollToTop />
                <LoadLanguageData />

                <Switch>
                    <Route path={urls.preview.home} />
                    <Route path={urls.singlepage} />
                    <Route>
                        <ErrorBoundary id="App_Loading">
                            <StartSession />
                            <LoadOrgConfig />
                            <LoadAppContent />
                        </ErrorBoundary>
                    </Route>
                </Switch>

                <Switch>
                    <PrivateRoute path={urls.external.home} component={External} loginUrl={`${urls.login}/${urls.loginParts.external}`} requiredAuthType={authTypes.external} />
                    <PrivateRoute path={urls.inside.home} component={Inside} loginUrl={urls.login} selectOrgUrl={`${urls.login}/${urls.loginParts.selectOrg}`} requiredAuthType={authTypes.user} />
                    <Route path={urls.public.home} component={Public} />
                    <Route path={urls.preview.home} component={Preview} />
                    <Route path={urls.singlepage} component={SingleTaskPage} />
                    <Route exact path={urls.home} component={OutsideRoute} />
                    <Route path={urls.outsideProgram.home} component={OutsideProgram} />
                    <Route path={urls.home} component={Outside} />

                    <Route component={PageNotFound} />
                </Switch>
            </>
        );
    }
}

export default hot(module)(withRouter(App));
